/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 */

import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route'

import type { RedirectContext } from '../types'

// The claim screen is public: stop before onboarding or the calendar redirect takes the visitor away.
export const trialClaimRedirect = ({ router, logger, params }: RedirectContext): unknown => {
  // Bootstrap yields '/trial-claim' under a router base without trailing slash.
  if (params.redirection?.path?.replace(/^\/+|\/+$/g, '') === 'trial-claim') {
    logger.debug('trial claim entrypoint >>> trial-claim')
    // The loop only stops on a truthy result and router.replace resolves undefined, so resolve to the route.
    return replaceWithResolvedRoute(router, { name: 'trial-claim' })
  }
}
